import { BrowserCacheLocation } from '@azure/msal-browser';
import { IAuthConfig } from '../auth.types';
import { loggerCallback } from '../logger/logger';

//  Ítem mockado para testes integrados
export const yduqs: IAuthConfig[] = [
  {
    envs: ['local'],
    brands: ['yduqs'],
    config: {
      type: 'msal',
      dados: {
        auth: {
          clientId: '567b6a3f-5bfe-4abb-93ca-496d0c5cacf6',
          authority: 'https://login.dev.wyden.com.br/wydendev.onmicrosoft.com/B2C_1_sava_candidato_sigin',
          knownAuthorities: ['login.dev.wyden.com.br', 'wydendev.b2clogin.com'],
          redirectUri: `${window.location.protocol}//${window.location.host}`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: false,
        },
        system: {
          loggerOptions: {
            loggerCallback,
          },
        },
        authoritySignUp: 'https://login.dev.wyden.com.br/wydendev.onmicrosoft.com/B2C_1_sava_candidato_signup',
        scope: 'https://wydendev.onmicrosoft.com/567b6a3f-5bfe-4abb-93ca-496d0c5cacf6/user.read',
      },
      extraQueryParameters: {
        marca: 'wyden',
        codigo_grupo_marca: '14',
        grupo_marca_label: 'wyden',
        base_origin: 'https://candidatos.dev.portal.wyden.com.br',
      },
    },
    applicationUrl: 'http://localhost',
  },
];
